// Remove margin-bottom from .custom-control for dropdown checkboxes
/* eslint-disable jsx-a11y/label-has-for */
import { useEffect, useState } from "react";
import { Button, Modal } from "react-blueprint-library";

import { useRef } from "react";
import { useSelector } from "react-redux";
import { downloadFile } from "../../../../api/uploadDownloadFiles";
import svgs, { svgType } from "../../../../assets/svgs";
import PDFFormsModal from "../PDFFormsModal";

import "./uploadModalDragAndDrop.scss";
import { CONTRACT_TYPE_DESCRIPTIONS } from "../../../../constants/Contract";

const candidateDocumentsContainerStyle = {
  width: "100%",
  height: "100%",
  padding: "24px",
  background: "#F7F7F7",
  borderRadius: "8px",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "24px",
  display: "inline-flex",
  marginBottom: "32px",
};

const modalHeaderRowStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: 32,
};

const noteStyle = {
  width: "100%",
  color: "#000",
  fontSize: "16px",
  fontFamily: "Lato",
  fontWeight: 400,
  lineHeight: "24px",
  wordWrap: "break-word",
  marginBottom: 32,
};

const modalHeaderTitleStyle = {
  color: "#000",
  margin: 0,
  fontSize: "20px",
  fontWeight: 600,
  lineHeight: "30px",
  letterSpacing: "0.25px",
  wordWrap: "break-word",
};

const closeButtonStyle = {
  margin: 0,
  padding: 0,
  position: "relative",
  top: 3,
};

const sectionStyle = {
  alignSelf: "stretch",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "24px",
  display: "flex",
  maxHeight: "300px",
  overflowY: "auto",
  overflowX: "hidden",
};

const titleStyle = {
  alignSelf: "stretch",
  color: "#555555",
  fontSize: "12px",
  fontFamily: "Lato",
  fontWeight: 500,
  textTransform: "uppercase",
  lineHeight: "16px",
  letterSpacing: "2px",
  wordWrap: "break-word",
};

const listStyle = {
  alignSelf: "stretch",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: "8px",
  display: "flex",
};

function useCustomControlStyle() {
  const styleRef = useRef(null);
  useEffect(() => {
    if (!document.getElementById("custom-control-unset-style")) {
      const style = document.createElement("style");
      style.id = "custom-control-unset-style";
      style.innerHTML = `.custom-control { margin-bottom: unset !important; height: 25px !important; text-align: center !important; }`;
      document.head.appendChild(style);
      styleRef.current = style;
    }
  }, []);
}

function CandidateDocModal({ isOpen, onClose, ...props }) {
  const [uploadedDocs, setUploadedDocs] = useState([]);
  const [requestedDocs, setRequestedDocs] = useState([]);

  const uploadedDocsSelector = useSelector(
    ({ uploadedReqDocs }) => uploadedReqDocs?.docs || [],
  );
  const requestedDocsSelector = useSelector(
    ({ uploadedReqDocs }) => uploadedReqDocs?.reqdocs || [],
  );
  const contractId = props?.contractid;

  const openModal = () => {
    if (typeof onClose === "function") onClose();

    setIsDocReqUploadModalOpen(true);
    setDocReqUploadModalData({
      contractid,
      oktaSubId: props?.oktasubid,
      contracttypedesc: props?.contracttypedesc,
    });
  };

  const {
    contracttypedesc = "",
    contractstatusdesc = "",
    contractid = "",
    mmlis = false,
    applicationStatus = "",
    isPriorContract = false,
    onlyCandidateDocs = false,
    setIsDocReqUploadModalOpen,
    setDocReqUploadModalData,
    ia = false,
  } = props;

  useEffect(() => {
    if (contractId && uploadedDocsSelector?.length) {
      const filteredDocs = uploadedDocsSelector.filter((d) => {
        return d.contractid === contractId && d.guid;
      });

      setUploadedDocs(filteredDocs);
    } else {
      setUploadedDocs([]);
    }
  }, [contractId, uploadedDocsSelector]);

  useEffect(() => {
    if (contractId && requestedDocsSelector?.length) {
      const filtered = requestedDocsSelector.filter(
        (doc) =>
          doc.contractid &&
          String(doc.contractid) === String(contractid) &&
          doc.requestStatus === "requested" &&
          !doc.guid,
      );
      setRequestedDocs(filtered);
    } else {
      setRequestedDocs([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractId, requestedDocsSelector]);

  useCustomControlStyle();

  useEffect(() => {
    if (isOpen) {
      const modal = document.getElementById("RequestDocModal");
      if (modal) {
        const contentDiv = modal.querySelector(".modal-content.default");
        if (contentDiv) {
          contentDiv.style.width = "480px";
          contentDiv.style.boxShadow = "0px 10px 12px -5px rgba(0, 0, 0, 0.15)";
          contentDiv.style.borderRadius = "8px";
        }
      }
    }
  }, [isOpen]);

  const handleDownload = async (file) => {
    try {
      const blob = await downloadFile({
        oktaSubId: file.oktasubid,
        fileId: file.guid,
      });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");

      link.href = url;
      link.download =
        file.originalname || `download.${blob?.type?.split("/")[1] || "bin"}`;
      document.body.appendChild(link);

      link.click();
      link.remove();
      setTimeout(() => URL.revokeObjectURL(url), 1000);
    } catch (err) {
      console.error("Download failed:", err);
      alert("Download failed. Please try again or contact support.");
    }
  };

  const renderList = () => (
    <ul style={{ paddingLeft: 8, listStyleType: "none" }}>
      {uploadedDocs.length === 0 && <li>No files available.</li>}
      {uploadedDocs.map((file, i) => (
        <li
          key={file.guid || file.type}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <div
            style={{
              width: 5,
              height: 5,
              background: "#767676",
              borderRadius: "9999px",
              marginRight: 12,
              flexShrink: 0,
              marginTop: 8,
              marginLeft: -4,
            }}
          />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "-webkit-fill-available",
            }}
          >
            <span
              style={{
                flex: 1,
                maxWidth: 290,
                minWidth: 290,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "inline-block",
                verticalAlign: "middle",
              }}
              title={file.originalname || file.typedesc}
            >
              {file.originalname || file.typedesc}
            </span>
            <span
              style={{
                color: "#888",
                fontSize: "12px",
                minWidth: 150,
                maxWidth: 325,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                display: "inline-block",
                verticalAlign: "middle",
              }}
              title={file.typedesc}
            >
              ({file.typedesc})
            </span>
          </div>
          <div
            style={{ marginLeft: 8, cursor: "pointer" }}
            onClick={async () => {
              return file.guid && (await handleDownload(file, i));
            }}
            disabled={!file.guid}
            role="presentation"
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <span
                style={{
                  width: 20,
                  height: 20,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  marginLeft: 4,
                }}
              >
                {svgs[svgType.downloadIcon]}
              </span>
            </div>
          </div>
        </li>
      ))}
    </ul>
  );

  const renderRequiredDocsList = () => {
    return (
      <ul style={{ paddingLeft: 8, listStyleType: "none" }}>
        {requestedDocs.length === 0 && (
          <li>No requested documents available.</li>
        )}
        {requestedDocs.map((doc, i) => (
          <li
            key={`${doc.type}-${i}`}
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: 12,
            }}
          >
            <div
              style={{
                width: 5,
                height: 5,
                background: "#767676",
                borderRadius: "9999px",
                marginRight: 12,
                flexShrink: 0,
                marginLeft: -4,
              }}
            />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                width: "-webkit-fill-available",
              }}
            >
              <span
                style={{
                  flex: 1,
                  maxWidth: 290,
                  minWidth: 290,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  display: "inline-block",
                  verticalAlign: "middle",
                }}
                title={doc.typedesc}
              >
                {doc.typedesc}
              </span>
            </div>
          </li>
        ))}
      </ul>
    );
  };

  const renderPDFFormsList = () => {
    return (
      <PDFFormsModal
        contracttypedesc={contracttypedesc}
        contractstatusdesc={contractstatusdesc}
        contractid={contractid}
        mmlis={mmlis}
        ia={ia}
        applicationStatus={applicationStatus}
        isPriorContract={isPriorContract}
      />
    );
  };

  return (
    <Modal
      id="RequestCanDocModal"
      show={isOpen}
      className="modal-md"
      title=""
      centered
    >
      <div style={{ padding: 32, minWidth: 400, maxWidth: 480 }}>
        <div style={modalHeaderRowStyle}>
          <h2 style={modalHeaderTitleStyle}>
            {props.contracttypedesc || "Candidate"} documents
          </h2>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close modal dialog"
            onClick={() => {
              if (typeof onClose === "function") onClose();
            }}
            style={closeButtonStyle}
          />
        </div>
        <div style={noteStyle}>
          We recommend saving a copy of these documents for your records.
        </div>

        {requestedDocs?.length ? (
          <div style={candidateDocumentsContainerStyle}>
            <div
              style={{
                ...sectionStyle,
                width: "100%",
                boxSizing: "border-box",
                paddingRight: "16px",
              }}
            >
              <div style={titleStyle}>Required documents</div>
              <div style={listStyle}>{renderRequiredDocsList()}</div>
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
              }}
            >
              <Button
                id="CandidateEndorsedContractUploadBtn"
                variant="primary"
                onClick={openModal}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    textTransform: "capitalize",
                  }}
                >
                  Upload Now
                  <span
                    style={{
                      width: 20,
                      height: 20,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginLeft: 4,
                    }}
                    className="uploadIconSVG"
                  >
                    {svgs[svgType.uploadIcon]}
                  </span>
                </div>
              </Button>
            </div>
          </div>
        ) : null}

        {uploadedDocs?.length ? (
          <div style={candidateDocumentsContainerStyle}>
            <div style={{ position: "relative" }}>
              <div
                style={{
                  ...sectionStyle,
                  width: "100%",
                  boxSizing: "border-box",
                  paddingRight: "16px",
                }}
              >
                <div style={titleStyle}>Candidate documents</div>
                <div style={listStyle}>{renderList()}</div>
              </div>
            </div>
          </div>
        ) : null}

        {onlyCandidateDocs ||
        (contracttypedesc === CONTRACT_TYPE_DESCRIPTIONS.FINANCING_ONLY &&
          !isPriorContract) ? null : (
          <div style={candidateDocumentsContainerStyle}>
            <div style={{ position: "relative", width: "100%" }}>
              <div
                style={{
                  ...sectionStyle,
                  width: "100%",
                  boxSizing: "border-box",
                  paddingRight: "16px",
                }}
              >
                <div style={titleStyle}>MassMutual documents</div>
                <div style={listStyle}>{renderPDFFormsList()}</div>
              </div>
            </div>
          </div>
        )}
      </div>
    </Modal>
  );
}

export default CandidateDocModal;
